import React, { useEffect, useState } from 'react'
import { useStyles } from '../report.style'
import { Paper, Grid, Box, Card, Typography, CardContent } from '@material-ui/core'
import clsx from 'clsx'
import { useSelector } from 'react-redux'

import { DoneAll, ReportProblem, Warning } from '@material-ui/icons'
import moment from 'moment'
//import { useHistory } from 'react-router'
import { FormValues } from '../../store/models/employeeData.model'
import { IReportsComponent } from '../../store/models'
import { XRayIcon } from '../icons/XRayIcon'
import { DoneAllIcon } from '../icons/DoneAllIcon'
import SearchService from '../../services/search.service'
import { SystemValues } from '../../store/models/systemValues.model'
import { ComplianceSubjectModel, ComplianceTaskListModel, ComplianceTaskModel } from '../../store/models/complianceTaskListModel'

const ReportsComponent: React.FC = () => {
    const classes = useStyles()
    //const history = useHistory()

    const reportData: ComplianceTaskListModel = useSelector((state: IReportsComponent) => state.report.tasks)
    const user: FormValues = useSelector((user: IReportsComponent) => user.report.user)
    
    const [systemValues, setSystemValues] = useState<SystemValues | null>(null);

    useEffect(() => {
        const loadSystemValues = async () => {
            try {
                const values = await SearchService.getSystemValues();
                setSystemValues(values);
            } catch (error) {
                console.error("Failed to load system values:", error);
            }
        };
        loadSystemValues();
    }, [])

    const renderTaskType = (task: ComplianceTaskModel) => {
        return task &&
        <Box>{task.taskName}
        {task.subjectFirstPassDate != null && <Box>{`Initial accreditation test date:
         ${moment(task.subjectFirstPassDate).format('DD/MM/yyyy')}`}</Box>}
        </Box>
    }

    return (
        <Paper className={clsx(classes.padding)} elevation={6}>
            {
                reportData && reportData.tasks && reportData.tasks.length > 0 ?
                    reportData.tasks.map((task: ComplianceTaskModel, x: number) => {
                        return (
                            task &&
                            <Card style={{ padding: 5, margin: 10 }} key={`Card${x}`}>
                                <Grid key={x} container spacing={2} alignItems="flex-end">
                                    <Grid item md={true} sm={true} xs={true}>
                                        <Box><Typography className={classes.taskTypeCaption}> {renderTaskType(task)}</Typography></Box>
                                    </Grid>
                                </Grid>
                                {
                                    task.subjects.map((subject: ComplianceSubjectModel, i: number) => {
                                        return (
                                            (subject.passFail  && subject.passFail.trim() !== '' || subject.score != null)
                                            && systemValues 
                                            && subject.dateCreated 
                                            && moment(subject.dateCreated).isAfter(moment().subtract(systemValues.portalHistoryInMonths, 'months'))
                                            && (
                                                <Card key={i} className={classes.cardView} raised style=
                                                {{ backgroundColor: 
                                                    moment(subject.expiredDate).isBefore(moment(), 'day') && subject.isExpired
                                                        ? '#f44336' // red for expired
                                                        : subject.score != null
                                                        ? '#2196F3' // blue for score-based subjects
                                                        : ((subject.executionLevelID && subject.executionLevelID >= 30) 
                                                            || subject.quantity
                                                           )
                                                                ? '#4CAF50' // green for passed/valid
                                                                : '#F44336' // red for not passed
                                                }}>
                                                    <Grid container>
                                                        <Grid item sm={2} md={2} lg={2}xl={2}>
                                                            <CardContent className={classes.cardContent} >
                                                                {
                                                                    subject.executionLevelID
                                                                        ? <Box>{subject.executionLevelID >= 30 
                                                                            ? <DoneAll className={classes.reportProblem} />
                                                                            : <ReportProblem className={classes.reportProblem} />}</Box> 
                                                                        : (
                                                                            subject.score 
                                                                                ? <Box>Score: {subject.score}</Box> 
                                                                                : <Box>Quantity: {subject.quantity}</Box>
                                                                        )                                                                    
                                                                }
                                                            </CardContent>
                                                        </Grid>
                                                            <Grid item sm={8} md={8} lg={8} xl={8}>
                                                                <CardContent className={clsx(classes.cardContent, classes.rightCol)} >
                                                                    {subject.isDisplayInPortal && <Box>{subject.subjectName}</Box>}
                                                                    {subject.executionLevelID && subject.executionLevelID >= 30 && <> <Box>{`Passed on ${moment(subject.dateCreated).format('DD/MM/yyyy')}`}</Box>
                                                                        {subject.isExpired && <Box>{`Expires on ${moment(subject.expiredDate).format('DD/MM/yyyy')}`}</Box>}</>}
                                                                    {subject.executionLevelID && subject.executionLevelID < 30 && <Box>{`Not passed on ${moment(subject.dateCreated).format('DD/MM/yyyy')}`}</Box>}
                                                                
                                                                    {/* {item.initDate != null && <Box>{`Initial accreditation test date: ${moment(item.initDate).format('DD/MM/yyyy')}`}</Box>} */}

                                                                    {/* {subject.score && subject.score >= 30 && <><Box>{`Passed on ${moment(subject.dateCreated).format('DD/MM/yyyy')}`}</Box>
                                                                        {subject.isExpired && <Box>{`Expires on ${moment(subject.expiredDate).format('DD/MM/yyyy')}`}</Box>}</>}
                                                                    {subject.score && subject.score < 30 && <Box>{`Not passed on ${moment(subject.dateCreated).format('DD/MM/yyyy')}`}</Box>} */}

                                                                    {subject.quantity && !subject.score && !subject.executionLevelID && <>
                                                                        <Box>{`Passed on ${moment(subject.dateCreated).format('DD/MM/yyyy')}`}</Box>
                                                                        {subject.isExpired && <Box> {`Expires on ${moment(subject.expiredDate).format('DD/MM/yyyy')}`}</Box>}</>}

                                                                </CardContent>
                                                            </Grid>
                                                        <Grid item sm={2} md={2} lg={2} xl={2}>
                                                            <CardContent className={classes.cardContent} >
                                                                <Box>
                                                                    {
                                                                        (subject.categoryId && subject.categoryId > 100000) ? <XRayIcon /> : <DoneAllIcon />
                                                                    }
                                                                </Box>
                                                            </CardContent>
                                                        </Grid>
                                                    </Grid>
                                                </Card>
                                            )
                                        )
                                    })
                                }
                            </Card >
                            
                        )
                    }) : <Card style={{ backgroundColor: '#c7c9c8', fontSize: '1em' }}>
                        <CardContent className={clsx(classes.cardContent, classes.rightCol)} >
                            <Grid container>
                                <Grid item xl={2}>
                                    <CardContent className={classes.cardContent} >
                                        <Warning className={classes.reportProblem} />
                                    </CardContent>
                                </Grid>
                                <Grid item xl={10}>
                                    <CardContent className={clsx(classes.cardContent, classes.rightCol)} >
                                        <Box>There are no results for {user.firstName} {user.lastName} </Box>
                                    </CardContent>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
            }
        </Paper >)
}

export default ReportsComponent